export default __webpack_public_path__ + "static/media/economic3.12234100.jpg";